module.exports = __webpack_public_path__ + "static/media/aiesec.c3e85f3a.png";